import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const getDefaultLine = () =>({

    product : null,
    items : null,
    adjusted_qty : null,
    diff : 0,
})

const getDefaultState = () => ({
  products : [],
  loadingProducts : true,
  reasons : [],
  reasonsOutdated : true,
  loadingReasons : true,
  onProduct : true,
  adjustment : {
    inventory_id : null,
    mode : 0,
    reference : null,
    effective_date : null,
    reason : null,
    description : null,
    items : [],
  },
  adjustedProduct : {
    product : null,
    items : null,
    item : null,
    adjusted_qty : null,
    diff : null,
  },
  defaultLine : getDefaultLine(),
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
